<template>
  <UModal
    v-if="isModalOpen"
    v-model:open="isModalOpen"
    class="w-full sm:max-w-md"
    :ui="{
      overlay: 'bg-gray-950/75 dark:bg-gray-950/90 z-[60]',
      header: 'flex items-center justify-between p-3 sm:px-3 min-h-12 bg-[#e9edf3] dark:bg-(--ui-bg-elevated)',
      content: 'z-[60]',
    }"
  >
    <template #header>
      <VisuallyHidden>
        <DialogTitle>{{ title }}</DialogTitle>
        <DialogDescription>{{ message }}</DialogDescription>
      </VisuallyHidden>
      
      <div class="flex items-center justify-between w-full">
        <h3 class="text-base font-semibold leading-6 text-(--ui-text)">
          {{ title }}
        </h3>
        
        <UButton
          color="gray"
          variant="ghost"
          icon="i-heroicons-x-mark"
          class="ml-2 cursor-pointer"
          tabindex="-1"
          @click="cancel"
        />
      </div>
    </template>
    
    <template #body>
      <div class="pb-4">
        <p class="text-sm text-gray-600 dark:text-gray-400">{{ message }}</p>
      </div>
      
      <div class="flex justify-end space-x-2">
        <UButton color="neutral" variant="outline" @click="cancel">
          {{ cancelText }}
        </UButton>
        <UButton :color="confirmColor" @click="confirm">
          {{ confirmText }}
        </UButton>
      </div>
    </template>
  </UModal>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { DialogTitle, DialogDescription, VisuallyHidden } from 'reka-ui'

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true
  },
  title: {
    type: String,
    default: 'Confirm Action'
  },
  message: {
    type: String,
    default: 'Are you sure you want to proceed?'
  },
  confirmText: {
    type: String,
    default: 'Confirm'
  },
  cancelText: {
    type: String,
    default: 'Cancel'
  },
  confirmColor: {
    type: String,
    default: 'primary'
  }
})

const emit = defineEmits(['update:modelValue', 'confirm', 'cancel'])

const isModalOpen = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

function confirm() {
  emit('confirm')
  
  isModalOpen.value = false
}

function cancel() {
  emit('cancel')
  
  isModalOpen.value = false
}
</script>
